// Horizon custom <Card> styleConfig (used app-wide via useStyleConfig("Card")).
// Colors come from the single-root semantic tokens so it themes automatically.
const Card = {
  baseStyle: {
    p: "20px",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    borderRadius: "20px",
    minWidth: "0px",
    wordWrap: "break-word",
    bg: "bg.surface", // near-white paper (light) / navy.800 (dark)
    color: "text.primary",
    borderWidth: "1px",
    borderColor: "border.subtle",
    boxShadow: "card",
    backgroundClip: "border-box",
  },
};

export const CardComponent = {
  components: {
    Card,
  },
};
